import type { Workitem } from '@rhythmic/db/types'
import type { CreateWorkitemPayload } from '@rhythmic/types'
import { CreateWorkitemPayloadSchema, generateUuid, WorkitemSchema } from '@rhythmic/types'
import type { Transaction } from '@tanstack/vue-db'
import { useRhythmicLogger } from '#imports'
import { getWorkitemsCollection } from '../getCollections'
import type { BacklogContext } from './useBacklogContext'

const logger = useRhythmicLogger('useBacklogContext:createWorkitem')

export function handleCreateWorkitem(
  payload: CreateWorkitemPayload,
  context: BacklogContext | undefined,
): Transaction<Workitem> {
  if (!context) throw new Error('Backlog context is not ready: missing team context')

  const { teamId, workspaceId } = context

  const parsedPayload = CreateWorkitemPayloadSchema.parse({
    ...payload,
    team_id: payload.team_id ?? teamId,
    workspace_id: payload.workspace_id ?? workspaceId,
  })

  const workitemRecord = WorkitemSchema.parse({
    ...parsedPayload,
    id: parsedPayload.id ?? generateUuid(),
    team_id: parsedPayload.team_id ?? teamId,
    workspace_id: parsedPayload.workspace_id ?? workspaceId,
  })

  logger.debug('Creating workitem from backlog context', {
    payload: parsedPayload,
    context,
  })

  const collection = getWorkitemsCollection(teamId)
  const transaction = collection.insert(workitemRecord)

  return transaction as Transaction<Workitem>
}
